module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "number1"
  }, [_vm._v("19. "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Create six “big picture” goals for the day.")]), _vm._v(" These can include both professional and personal goals. For instance, one of your goals might be to finish a big work project, while another might be to start planning your upcoming family vacation. The idea here is for you to give yourself a “big picture” vision of what you hope to accomplish so you can better steer your daily schedule and yourself toward those goals.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("20. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Break your to-do list down into small, actionable steps.")]), _vm._v(" For instance, instead of putting something like “work on the Rogers project” on your to-do list, break the task down into smaller, more specific steps like “email the Rogers client,” “schedule a call with Smith about the Rogers project,” and “research stats for the Rogers project.” By breaking down the larger item, you’re thinking through the details of what needs to get done. You’ll also feel a lot more accomplished when you’ve knocked off ten items from your to-do list before lunch rather than none because you’re still working on that same large task.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("21. ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Set ninety-day goals rather than yearly ones.")]), _vm._v(" Everything can change in a year. While many of us spend the beginning of the year creating goals for what we hope to accomplish by December 31, it’s better to set goals you’d like to finish by March 31 instead. Come April, you can evaluate how close you are to reaching those goals (if you haven’t reached them already) and revamp them—or create new goals—for continued success in the following three months. Even if you haven’t reached your original goal, you’re now on track to reach it in the next time frame.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("22. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Remembering passwords can be difficult, especially if you have a number of different ones to keep track of.")]), _vm._v(" A password manager, such as the app 1Password, can not only keep track of your passwords but also help you come up with supersecure passwords. There’s nothing worse than needing access to a tool and having to waste time searching for the password or resetting it so you can get in.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("23. ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Eat right.")]), _vm._v(" You’ve probably heard the saying “You get out of something what you put into it.” That goes for your body as well. One of the cornerstones of being your most productive self is eating well. While grabbing a burger or takeout might be your fastest option, you’re much better off ensuring that you eat healthy, nutritious meals that give your body and your mind the right kind of fuel to get things done throughout the day. After all, you are what you eat!")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("24. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Give each day a theme.")]), _vm._v(" When each day has its own theme, it’s easier to create your schedule for the week, stay on task, and make sure none of the aspects of your job are overshadowed by another. For instance, Mondays might be for looking for new business, while Tuesdays might be for meeting with your staff and/or clients or reviewing the business you already have. Using themes can also help you stay in the right headspace throughout the day since you won’t be switching gears constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("25. ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Leave your car keys with important materials you need to bring with you.")]), _vm._v(" You can’t be productive when you’ve left crucial items behind. Keeping your keys with those items ensures that when you’re on the hunt for the keys in the morning, you’ll be reminded to bring those important things with you when you head off to work.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("26. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Set all of your recurring bills up on autopay.")]), _vm._v(" If a service you use doesn’t offer an autopay option but you always pay the same amount, you can set up your own version of autopay using your bank’s Bill Pay feature. When you don’t have to spend time paying bills every month, you have more time to focus on other tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("27. ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Save longer online articles for your downtime.")]), _vm._v(" Thanks to modern technology, information from a variety of different news organizations is always at your fingertips. It’s great to read those longer articles on current events and cultural perspectives, but it can also take a ton of time. Use the downtime, whether it is while you’re on the elliptical at the gym or on the train commuting home, to enjoy those saved articles (or blog posts or videos). You’re saving yourself time in a moment when you need to be productive while giving yourself something entertaining to do later on.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("28. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Be honest.")]), _vm._v(" Lying might seem like a solution in the moment, but it will come back to get you later. If you tell your boss a project is almost done when you haven’t started, he will think you’re ready to take on more work. Honesty will save you time and potential awkwardness or a loss of credibility when you have to dig yourself out from under the lie later.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("29. ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Track your accomplishments.")]), _vm._v(" Inevitably during the day you’re going to accomplish a lot of tasks that aren’t on your to-do list but still need to be done. Whenever you do anything productive (no matter how small), write it down. By the end of the day, you’ll have a long list of accomplishments to celebrate, even if some of them weren’t things you originally set out to do. Those reminders of your productivity can be a motivating boost in keeping up your good work!")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("30. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Schedule your errands based on location.")]), _vm._v(" For instance, if you have to drop your son off at soccer practice in a town where your optometrist also happens to be, then perhaps you can pick up your contact prescription while he’s practicing rather than the day before or after. If the grocery store is next door to where your daughter takes piano lessons, then you should make a habit of grocery shopping while she is at a lesson. Planning tasks around a location can cut down on your commute and overall time spent on a task.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("31. ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Let your calendar do the remembering.")]), _vm._v(" No one can remember everything. Whenever a new task comes up, add time to work on that task to your calendar. For tasks that can’t be specifically scheduled, set a reminder for yourself for a time or date when you aim to accomplish that task by. For instance, if you want to call a restaurant tomorrow to make a reservation, set a reminder for late in the afternoon to do it, just in case you lose track of time or forget about it.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("32. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Give everything a dedicated place in your home or office.")]), _vm._v(" You don’t necessarily have to have a place for every single item, but try to at least organize things by general location. For instance, keep all of your power cables in a specific drawer in your desk, or all of the manuals you own in a specific box in your bedroom closet. When you need a new charging cable for your phone or instructions for the air conditioner, you’ll at least have a general idea of where to look to find it a lot faster.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("33. "), _c('span', {
    staticClass: "txbf"
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Create a shared grocery list with your family. Ideally, this is a digital list that everyone can access on the phone or computer. Since everyone can add to it, when one person finds herself at the store (or with the time to go to the store), she can grab everything the family needs so multiple trips aren’t necessary. There are a number of different apps out there that allow you to make shared lists, including Evernote and Google Keep.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("34. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Keep your “enemies” closer.")]), _vm._v(" You can often learn a lot from your competition. Make a point to surround yourself with people who have viewpoints different from your own. If you have a colleague in a similar position whom you always butt heads with, try to work on teams with him rather than avoiding him. When you can see someone else’s perspective on an issue, you’ll be much better at finding an equitable solution for everyone involved. Hearing outside perspectives and learning from them can also sharpen your own perspective on a particular issue. When your solution takes multiple viewpoints into account from the beginning, it’s less likely to need revising later down the line.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("35. ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Make sure your daily to-do list includes a step toward a larger goal.")]), _vm._v(" This way you’re doing something small in the moment, but you’re also setting the stage to complete a much larger project in the future. For instance, if you have the larger goal of being fluent in German before your business trip to Berlin in five months, then block off time each day to work on it. Not all goals can be attained overnight!")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("36. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Hold regular check-in meetings with your family to discuss family business.")]), _vm._v(" Set biweekly or monthly meetings with everyone to talk about upcoming family events and whatever else is on their minds. This can be as simple as making sure everyone has a ride home from school for the week or as involved as planning your next family vacation. When your family members are all on the same page, you save everyone the time and stress of haphazardly trying to deal with issues in the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("37. ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("If you have a drink you really enjoy after work, consider mixing up several at the beginning of the week and keeping them in the fridge so they’re ready to go when you get home.")]), _vm._v(" This obviously won’t work for everything, but drinks like margaritas or even Negronis can be mixed together in larger batches and stored in your fridge. Premade cocktails are also great when you have last-minute guests and will allow you to focus on your friends, not your bartending skills (or lack thereof). Who knew margaritas could actually be productive?")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("38. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Set items you use regularly to autoship to your home when you know you’ll be almost out.")]), _vm._v(" Many retailers now offer subscriptions to a number of household items like toilet paper, razors, and dish soap. If you don’t want to commit to having something autoshipped, Amazon’s Dash Buttons are a great alternative. Keep the Buttons in places like your laundry room for detergent and your bathroom for toilet paper; your family members can tap the Button when they notice the supply is running low, and Amazon will send a replacement before it runs out.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47738c8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01c.vue
// module id = 81
// module chunks = 0